import { ToyType, ToyCondition, ToyPurchaseCondition } from './constants';

const attributes = {
  toy_type: {
    friendly: 'Type',
    validations: {
      type: 'enum',
      enumType: ToyType,
    },
  },
  toy_manufacturer: {
    friendly: 'Manufacturer',
    validations: {
      maxLength: 255,
    },
  },
  toy_series: {
    friendly: 'Series',
    validations: {
      maxLength: 255,
    },
  },
  toy_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },
  toy_year_produced: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  toy_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },
  toy_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },
  toy_packagingtoy_type: {
    friendly: 'Packaging',
    validations: {
      maxLength: 255,
    },
  },
  toy_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },
  toy_manufacturing_no: {
    friendly: 'Manufacturing No.',
    validations: {
      maxLength: 255,
    },
  },
  toy_asst_no: {
    friendly: 'Assortment No.',
    validations: {
      maxLength: 255,
    },
  },
  toy_upc: {
    friendly: 'UPC No.',
    validations: {
      maxLength: 255,
    },
  },
  toy_msrp: {
    friendly: 'MSRP',
    validations: {
      maxLength: 255,
    },
  },
  toy_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: ToyCondition,
    },
  },
  toy_purchase_condition: {
    friendly: 'Purchase condition',
    validations: {
      type: 'enum',
      enumType: ToyPurchaseCondition,
    },
  },


};

export default attributes;

export const ToyDefaultSplitAttribute = 'toy_type';

export const ToyItemSearchAttributes = [];

export const ToyOverviewAttributes = ['title', 'toy_type', 'toy_manufacturer', 'toy_year_produced', 'toy_country_of_origin',
  'toy_condition', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const ToySpecificationAttributes = ['toy_series', 'toy_edition', 'toy_msrp', 'toy_manufacturing_no', 'toy_asst_no', 'toy_upc',
  'toy_dimensions', 'toy_packagingtoy_type', 'toy_accessories'];

export const ToyPurchaseAttributes = ['purchase_date', 'purchase_price', 'toy_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const ToyDetailAttributes = [];

export const ToyRequiredAttributes = [];

export const ToyDisplayAttributes = ['toy_type', 'toy_manufacturer', 'toy_series', 'toy_edition', 'toy_dimensions', 'tags'];

export const ToySliderGalleryAttributes = {
  titleKey: 'toy_type',
  subtitleKey: 'toy_manufacturer',
};



// WEBPACK FOOTER //
// ./src/config/toyDataAttributes.js